import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('authkey') && localStorage.getItem('apikey')) {
            // logged in but first check if email is verified
            if (sessionStorage.getItem('yheyhhshshveri') && sessionStorage.getItem('yheyhhshshveri') == 'atyyctjsjsiggv===') {
                // logged in so return true
                return true;
            }

            this.router.navigate(['/account/email-verify'], { queryParams: { returnUrl: state.url }});
            return false;
        }

    
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}